import { useState } from 'react'

import { useRouter } from 'next/router'

type ThemeResult = {
	hitsPerPage: number
	nbHits: number
	nbPages: number
	hits: {
		slug: string
		title: string
		description: string
		largeThumbnail: string
		pricePlainText: string
		related: string[]
		objectID: string
		publishedAt: string
	}[]
	page: number
	query: string
	params: string
}

export const useThemesList = () => {
	const { query, isReady } = useRouter()
	const [searchUrl, setSearchUrl] = useState<string>()
	const [results, setResults] = useState<ThemeResult>()
	const [isLoading, setIsLoading] = useState<boolean>(false)

	const industry =
		typeof query.slug === 'string'
			? query.slug
			: Array.isArray(query.slug)
			? query.slug[0]
			: undefined

	const url = buildSearchUrl()
	if (isReady && !isLoading && searchUrl !== url) {
		setSearchUrl(url)
		fetchThemes(url)
	}

	async function fetchThemes(url: string) {
		setIsLoading(true)
		try {
			const response = await fetch(url)
			const data = await response.json()
			setResults(data as ThemeResult)
		} catch (e) {
			console.error(e)
			throw new Error('Error fetching marketplace themes from Algolia')
		} finally {
			setIsLoading(false)
		}
	}

	function buildSearchUrl() {
		let url = `/api/algolia/marketplace/themes/themes-list/?env=${process.env.NODE_ENV}`
		if (typeof query.query === 'string') url = `${url}&searchQuery=${query.query}`
		if (typeof query.page === 'string') url = `${url}&page=${query.page}`
		if (typeof query.collection === 'string') url = `${url}&collection=${query.collection}`
		if (industry) url = `${url}&industry=${industry}`
		if (typeof query.price === 'string') url = `${url}&price=${query.price}`
		return url
	}

	return { searchUrl, results, isLoading }
}
